const name = 'Organisation Participant Summary Report';
export const INITIALIZE = `[${name}] Initialize`;
export const DESTROY = `[${name}] Destroy`;
export const LOAD_ORGANISATIONS = `[${name}] Load Organisations`;
export const LOAD_ORGANISATIONS_DONE = `[${name}] Load Organisations Done`;
export const UPDATE_SELECTED_ORGANISATION_ID = `[${name}] Update Selected Organisation ID`;
export const REPORT_LOADED = `[${name}] Report Loaded`;
